import _ from 'lodash';
import { connect } from 'react-redux';
import { getBlockSuggestions, add, update, get } from '../../modules/ocr/ocrGuide';
import { showErrors } from '../../modules/general';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state, ownProps) => {
	const ocrGuideId = _.get(ownProps, ['match', 'params', 'ocrGuideId']);
	const ocrGuide = ocrGuideId ? _.get(state.maps, ['ocrGuide', ocrGuideId]) : undefined;

	return {
		ocrGuide,
		userMap: state.maps.user,
		carrierMap: state.maps.carrier,
		supplierMap: state.maps.supplier,
		terminalMap: state.maps.terminal,
		resourceMap: state.maps.resource,
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			getBlockSuggestions,
			ocrGuideAdd: add,
			ocrGuideUpdate: update,
			ocrGuideGet: get,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
